import React, {useState, useEffect} from 'react';
import QuestionRenderer from './QuestionRenderer';

const MasteryPhase = ({question, questionIndex, totalQuestions, masteryAnswers, onSubmit, onNext}) => {
  const [submitted, setSubmitted] = useState(false);
  const [isCorrect, setIsCorrect] = useState(null);

  useEffect(() => {
    setSubmitted(false);
    setIsCorrect(null);
  }, [questionIndex]);

  const handleSubmit = (selectedAnswer) => {
    const correct = selectedAnswer === question.correctAnswer;
    setIsCorrect(correct);
    setSubmitted(true);
    onSubmit(selectedAnswer);
  };

  return (
    <div className="lcv-check-panel lcv-mastery-panel">
      <div className="lcv-check-header">
        <span className="lcv-check-badge lcv-mastery-badge">MASTERY TEST</span>
        <span className="lcv-check-count">Question {questionIndex + 1} of {totalQuestions}</span>
      </div>

      <div className="lcv-mt-progress">
        {Array.from({length: totalQuestions}).map((_, i) => {
          let dotClass = 'lcv-dot-pending';
          if (i < masteryAnswers.length) {
            dotClass = masteryAnswers[i].correct ? 'lcv-dot-correct' : 'lcv-dot-incorrect';
          } else if (i === questionIndex) {
            dotClass = 'lcv-dot-current';
          }
          return <div key={i} className={`lcv-mt-dot ${dotClass}`} />;
        })}
      </div>

      <QuestionRenderer
        question={question}
        onSubmit={handleSubmit}
        showFeedback={submitted}
        isCorrect={isCorrect}
      />

      {submitted && (
        <>
          <div className={`lcv-feedback ${isCorrect ? 'lcv-fb-correct' : 'lcv-fb-incorrect'}`}>
            <span>{isCorrect ? '✅' : '❌'}</span>
            <span>{isCorrect ? 'Correct!' : `Incorrect. The answer is: ${question.correctAnswer}`}</span>
          </div>
          <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: 16}}>
            <button className="lcv-btn-primary lcv-btn-purple" onClick={onNext}>
              {questionIndex + 1 < totalQuestions ? 'Next Question' : 'See Results'}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default MasteryPhase;
